const NJAL_SLUG = 'njal'
const BOGOTA_SLUG = 'bogota-fashion-week'
const CABANA_SLUG = 'cabana-capsule'
const ONTIME_SLUG = 'ontimeshow'
export const NEW_BRAND_PROFILE_SLUGS = [
  BOGOTA_SLUG,
  CABANA_SLUG,
  ONTIME_SLUG,
  NJAL_SLUG,
]

export const minPriceOptions = ['$10', '$50', '$100', '$250', '$500']
export const maxPriceOptions = ['$150', '$250', '$500', '$750', '$1000']

export const EVENT_LANDING_V2_ALLOWED_SLUGS = [
  'on-trend-womens-fall-2023',
  'on-trend-womens-spring-2024',
  'on-trend-womens-fall-2024',
  'joor-100-top-global-retailers-2024',
  'on-trend-womens-spring-2025',
]

export const containerStyle =
  'tw-px-4 tw-mb-16 tw-flex tw-flex-col tw-items-center tw-justify-center tw-min-w-full tw-h-auto'

export const styleStoriesLayouts = {
  V0: 'V0',
  V1: 'V1',
  V2: 'V2',
  V3: 'V3',
}

export const editorialLayouts = {
  V0: 'V0',
  V1: 'V1',
}

export const defaultColorBlue = '#5C7284'

// These pixel values should match variables set in EventLanding.component.less and other component CSS files
export const dimensions = {
  archivedShow: { width: 935, height: 700 },
  editorial: {
    V3: { width: { xl: 1200, lg: 1000, md: 800, sm: 600 } },
  },
  filters: { width: { xl: 985, lg: 865, md: 785, sm: 725 } },
  screen: { width: { lg: 1200, md: 1075, sm: 700 } },
  styleStories: {
    xl: 1250,
    lg: 1050,
    md: 850,
    sm: 800,
    xs: 750,
    tiny: 650,
    V2: { charLimit: { lg: 21, md: 21, sm: 21 } },
  },
}

// TODO(ch81263) Since cypress test scenarios are not associated with data in contentful
export const asContentfulData = (eventCF) => {
  const randomImg = 'https://placedog.net/950/950?random&b=15'
  const currentEventCF = {
    ...eventCF,
    images: {
      mainHero: randomImg,
      landingHero: randomImg,
      tile: randomImg,
      logo: randomImg,
    },
  }
  return [currentEventCF]
}
